import { z } from 'zod'
import { queryDateTime } from '../common/query-date'

export const incomesQuerySchema = z.object({
  startDate: queryDateTime,
  endDate: queryDateTime,
})

export type IncomesQueryDto = z.infer<typeof incomesQuerySchema>
